export default {
    storeSendChatbotFeedback: { method: 'post', url: 'chat/send-feedback' },
    putChatbotFeedback: { method: 'put', url: 'chat/update-feedback/{id}' },
    getChatbotFeedback: { method: 'get', url: 'chat/feedbacks' }
}
